// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import VoterIdDetailsActionType from './voter-id-details.types';
import {
	updateVoterIdSuccess,
	updateVoterIdFailure,
	updateVoterIdResponseChanged,
} from './voter-id-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { voterIdUpdateDetails } from './voter-id-details.service';

/** ***************** UPDATE VOTER ID START ************************/
export function* updateVoterIdDetails({ payload }: any) {
	try {
		const key = 'updateVoterIdID';
		const {
			companyID,
			databaseName,
			memberID,
			memberVoterIdFrontImg,
			memberVoterIdBackImg,
			proofType,
			docType,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberVoterIdFrontImg: memberVoterIdFrontImg,
			MemberVoterIdBackImg: memberVoterIdBackImg,
			ProofType: proofType,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};

		const voterIdData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(voterIdUpdateDetails, voterIdData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateVoterIdFailure(responseData.data));
		} else {
			yield put(updateVoterIdSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateVoterIdFailure(error));
	}
}

export function* updateVoterIdDetailsResponseClear() {
	yield put(updateVoterIdResponseChanged());
}

export function* onVoterIdDetailsUpdateStart() {
	yield takeLatest(VoterIdDetailsActionType.UPDATE_VOTER_ID_START, updateVoterIdDetails);
}

export function* onVoterIdDetailsUpdateResponseRest() {
	yield takeLatest(
		VoterIdDetailsActionType.UPDATE_VOTER_ID_RESPONSE_REST_START,
		updateVoterIdDetailsResponseClear,
	);
}
/** ***************** UPDATE VOTER ID END ************************/

export function* voterIdDetailsSaga() {
	yield all([call(onVoterIdDetailsUpdateStart), call(onVoterIdDetailsUpdateResponseRest)]);
}
